<template>
	<div class="score-card" :class="{ 'score-card-green': score > 7, 'score-card-orange': score >= 4 && score < 7, 'score-card-red': score < 4 }">
		<router-link :to="{ name: routeName, params: { id: id } }" class="score-card-link">
			<div class="score-card-main">
				<ScoreHappyIcon v-if="score >= 7"/>
				<ScoreAverageIcon v-if="score >= 4 && score < 7"/>
				<ScoreSadIcon v-if="score < 4"/>
				<div class="score-card-text">
					<span class="score-card-title">Happiness Score</span>
					<div class="score-card-total">
						<span class="score-card-result">{{ score }}</span>
						<span class="score-card-total-max">/ 10</span>
					</div>
				</div>
			</div>
			<span class="score-card-date eyebrow">{{ date }}</span>
		</router-link>
	</div><!-- card -->
</template>

<script>
import ScoreHappyIcon from '@/assets/score-happy.svg';
import ScoreAverageIcon from '@/assets/score-average.svg';
import ScoreSadIcon from '@/assets/score-sad.svg';
export default {
	name: 'ScoreCard',
	props: {
		score: Number,
		date: String,
		routeName: String,
        id: String
	},
	components: {
		ScoreHappyIcon,
		ScoreAverageIcon,
		ScoreSadIcon
	}
};
</script>

<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	.score-card {
		position: relative;
		padding: 17px;
		border-radius: 12px;
		border: 1px solid #EEF0F3;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 14px;
		background: #FFFFFF;
	    box-shadow: 5px 15px 15px 5px #EEF0F3;
		&:last-of-type {
			margin-bottom: 0;
		}
		&.score-card-green {
			.score-card-main svg {
				.fill {
					fill: $green_base;
				}
				.stroke {
					stroke: $green_base;
				}
			}
			.score-card-total {
				color: $green_base;
			}
		}
		&.score-card-orange {
			.score-card-main svg {
				.fill {
					fill: $yellow_base;
				}
				.stroke {
					stroke: $yellow_base;
				}
			}
			.score-card-total {
				color: $yellow_base;
			}
		}
		&.score-card-red {
			.score-card-main svg {
				.fill {
					fill: $red_base;
				}
				.stroke {
					stroke: $red_base;
				}
			}
			.score-card-total {
				color: $red_base;
			}
		}
		.score-card-link {
			display: flex;
		    justify-content: space-between;
		    width: 100%;
		}
		.score-card-main {
			display: flex;
			align-items: center;
			svg {
				height: 35px;
				width: auto;
				margin-right: 15px
			}
		}
		.score-card-date {
			opacity: 0.5;
		}
		.score-card-text {
			display: flex;
    		flex-direction: column;
    		align-items: flex-start;
    		.score-card-title {
    			color: #6D7A8B;
    			opacity: 0.5;
    			line-height: 14px;
    			font-size: 14px;
    			letter-spacing: -0.41px;
    			margin-bottom: 7px;
    		}
    		.score-card-total {
 				position: relative;
 				font-weight: 600;
 				line-height: 14px;
 				.score-card-result {
 					font-size: 17px;
 				}
 				.score-card-total-max {
 					font-size: 14px;
 					opacity: 0.7;
 					margin-left: 5px;
 				}
    		}
		}
	}
</style>
